import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { findByUsuario } from './api-aluno-responsavel';
import { changeARAluno } from '../Usuario/api-usuario';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { setUsuario } from '../Usuario/actions/actions';
import { Grid } from '@mui/material';
import GridPaper from '../../util/GridPaper';

export default function AlunoResponsavelAtivoTable() {
    const usuario = useSelector(state => state.usuario);
    const [alunosReponsavel, setAlunosReponsavel] = useState([]);
    const dispatch = useDispatch();


    useEffect(() => {
        if (usuario && usuario.id) {
            findByUsuario(usuario.id).then((data) => {
                if (data) {
                    setAlunosReponsavel(data);
                }
            });
        }

    }, [usuario]);


    const handleAtivar = (aluno) => {
        changeARAluno(aluno).then((data) => {
            if (data) {
                dispatch(setUsuario(data));
                toast.success("Aluno Selecionado.", {
                    position: "bottom-left"
                });
            }
        });
    }

    return (
        <div>
            {alunosReponsavel.length > 0 ?

                <Grid container spacing={3} direction='column'>
                    <Grid>
                        <Typography variant="h5">
                            Alterar Aluno Selecionado
                        </Typography>
                    </Grid>
                    <GridPaper>
                        <Table size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Aluno</TableCell>
                                    <TableCell>Ações</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {alunosReponsavel.map((ar) => (
                                    <TableRow key={ar.codigo}>
                                        <TableCell>{ar.aluno.nome}</TableCell>
                                        <TableCell>
                                            {!usuario.arAlunoSelecionado || usuario.arAlunoSelecionado.codigo !== ar.aluno.codigo ?
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={() => handleAtivar(ar.aluno)}
                                                >
                                                    Selecionar
                                                </Button>
                                                : 'Selecionado'}

                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </GridPaper>
                </Grid>

                : ''
            }
        </div >
    );
}